<ng-template #modalContent let-modal>
  <ds-modal [modal]="modal" [title]="'delete_apikey_modal_title' | translate" [colorVariant]="dsModalColorVariant.Default">
    <form [formGroup]="form" (ngSubmit)="onConfirm()">
      <div class="d-flex flex-column margin-bottom" [formGroup]="form">
        <h3>{{ 'delete_apikey_modal_header' | translate }}</h3>

        <span class="margin-bottom-md">{{ 'required_fields_label' | translate }}</span>

        <app-common-input
          [context]="{ field: 'confirmation', autocomplete: 'off', label: 'delete_apikey_modal_text_to_type_label' }"
          [form]="form"
          [formValidationRequest$]="formValidationRequest"
        ></app-common-input>
      </div>

      <button ds-button [variant]="dsButtonVariants.primary" type="submit">
        {{ 'label_delete' | translate }}
      </button>
    </form>
  </ds-modal>
</ng-template>
